import React, { useState, useRef, useEffect } from "react";
import "./CustomerCertificates.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const CustomerCertificates = () => {
  const componentRef = useRef();
  // const formRef = useRef();
  const [company, setCompany] = useState(null);
  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  const mainDomain = parts.slice(-2).join(".");
  const [imageurl,setimageurl]=useState(null);
  const [customerPhoto,setCustomerPhoto]=useState(null);

const selectedCustomer = location.state?.row || null;

  // console.log("profile: ", profile);
  const data = {
    name: " Amit ",
    panNumber: "WEHJEF21746EF ",
    aadharNumber: "7643282186234",
    title: "DR.",
    gender: "Male",
    dob: "04/05/1990",
    fullName: "Amit Sharma",
    parent: "XYZ",
    mobile: "8973428893",
    email: "amit@gmail.com",
    pin: "934287",
    postOffice: "Ahiyapur",
    bankAccount: "248921349786342",
    ifsc: "SBIN098479043",
    bankBranch: "Muzaffarpur",
    bankName: "SBI",
    subDistrict: "Zero Mile",
    district: "Muzaffarpur",
    state: "Bihar",
    country: "India",
    cAddress: "Ahiyapur",
    pcAddress: "Zero mile,Ahiyapur,Muzaffarpur-822001",
    marital: "Married",
    doj: "12/06/2022",

    address: "Ahiyapur,Muzaffarpur-822001",
    cin: "UIR3486375538",
    contact: "9832423734",
    email: "techvision@gmail.com",
    domain: "https://techvision.com",
  };



  // pdf generate

  const generatePDF = async () => {
    const input = componentRef.current;
    if (!input) {
      console.error("❌ componentRef is null — element not found!");
      return;
    }

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#fff",
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    // for long certificate
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    pdf.save(`${selectedCustomer?.fullName}_CustomerForm.pdf`);
  };

  // fetch customer and company details
  // Fetch Profile (runs once)
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // Fetch Company and Nominee
  useEffect(() => {
    const fetchAllData = async () => {
      if (!profile?.superAdminId) return; // Stop if profile not loaded yet

      // Fetch Company
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
        );
        const companyData = await res.json();

        if (res.ok) {
          // Fix logo URL
          if (companyData.logo) {
            companyData.logoUrl = `https://payyug.in/${companyData.logo.replace(
              /^images\//,
              ""
            )}`;
          }

          console.log("company data", companyData)
          setCompany(companyData);
        } else {
          console.error("Company fetch failed:", companyData);
        }
      } catch (err) {
        console.error("Company fetch error:", err);
      }
    };

    fetchAllData();
  }, [profile?.superAdminId]);

  // fetch customer
  // const customerPhoto=location.state?.customerPhoto || null;
  // console.log("customerPhoto: ", customerPhoto);
  // useEffect(() => {
  //   if (!selectedCustomer) {
  //     console.warn("No customer data received!");
  //   }
  // }, [selectedCustomer]);


  const fetchCustomerPhoto = async () => {
    const userId=selectedCustomer.userId;
    try {
      if (!userId) return null;

      const res = await fetch(
        // `https://payyug.in/api/list-kyc?userId=${userId}&superAdminId=${profile?.superAdminId}`
        `https://payyug.in/api/list-kyc?userId=${userId}&superAdminId=${profile?.superAdminId}&createdId=${profile.id}`
      );

      if (!res.ok) return null;

      const data = await res.json();

      const photoDoc = data?.documents?.find(
        (doc) => doc?.docName?.toLowerCase() === "photo"
      );

      if (photoDoc?.docImage) {
        setCustomerPhoto(`https://payyug.in/uploads/${photoDoc.docImage}`);
      }

      return null;
    } catch (err) {
      console.error("Photo fetch error:", err);
      return null;
    }
  };

  useEffect(()=>{
    fetchCustomerPhoto();
  },[profile?.superAdminId])

  return (
    <div>
      <div className="Customer-Certificates-wrapper" ref={componentRef}>
        {/* ---------------- Header ---------------- */}
        <div id="page2"></div>

        {/* ---------------- Header ---------------- */}
        <div className="Customer-Certificates-Branch-header">
          <div className="Customer-Certificates-Branch-logo-box">
            <img
              src={company?.logoUrl}
              alt="logo"
              className="Customer-Certificates-Branch-logo"
            />
          </div>

          <div className="Customer-Certificates-Branch-company-details">
            <h2 className="Customer-Certificates-Branch-company-name">
              {company?.name || "Techvision"}
            </h2>
            <p>
              <b>Address:</b> {company?.address || "-"}
            </p>
            <p>
              <b>CIN:</b> {company?.cin || "-"}
            </p>
            <p>
              <b>Mobile:</b> {company?.contact || "-"}
            </p>
            <p>
              <b>Email:</b> {company?.email || "-"}
            </p>
            <p>
              {/* <b>Website:</b> {company?.domain || "-"} */}
              <b>Website:</b> {mainDomain || "-"}
            </p>
          </div>
         <div className="Customer-Certificates-Branch-logo-box"  style={{ visibility: "hidden" }}>
            <img
              src={company?.logoUrl}
              alt="logo"
              className="Customer-Certificates-Branch-logo"
            />
          </div>

        
          
        </div>

        {/* ---------------- Title ---------------- */}
        <h2 className="Customer-Certificates-Branch-title">
          Customer Application Form
        </h2>
        {/* ✅ Attach ref here */}

        {/* Certificate Content */}
        <h3 className="Customer-Certificates-title">PERSONAL INFORMATION</h3>
        <table className="Customer-Certificates-table">
          <tbody>
            <tr>
              <td colSpan={1}>
                <strong>Name :</strong> {selectedCustomer.fullName || "N/A"}
              </td>
              <td>
                <strong>Pan Number :</strong> {selectedCustomer.panNumber|| "N/A"}
              </td>
              <td rowSpan={3} className="Customer-Certificates-box">
                  {customerPhoto ? (
                    <img
                      src={customerPhoto}
                      alt="Customer"
                      className="Customer-Certificates-photo"
                      crossOrigin="anonymous"
                    />
                  ) : (
                    <div className="Customer-Certificates-placeholder">
                      No Photo
                    </div>
                  )}
                </td>

            </tr>
            <tr>
              <td>
                <strong>Aadhaar Number :</strong>{" "}
                {selectedCustomer.aadhaarNumber|| "N/A"}
              </td>
              <td>
                <strong>Title :</strong>
                {selectedCustomer?.fullName &&
                selectedCustomer.fullName.trim().split(" ").length > 1
                  ? selectedCustomer.fullName.trim().split(" ").slice(-1)[0] // last name
                  : "N/A"}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Gender :</strong> {selectedCustomer.gender|| "N/A"}
              </td>
              <td>
                <strong>DOB :</strong>{" "}
                {new Date(selectedCustomer.dateOfBirth).toLocaleDateString(
                  "en-GB"
                )|| "N/A"}
              </td>
            </tr>
          </tbody>
        </table>

        <h3 className="CustomerCertificatessection-title">Contact & Banking</h3>
        <table className="CustomerCertificatesinfo-table">
          <tbody>
            <tr>
              <td>
                <strong>Full Name :</strong> {selectedCustomer.fullName|| "N/A"}
              </td>
              <td>
                <strong>Parent's Name :</strong> {selectedCustomer.guardianName|| "N/A"}
              </td>
              <td>
                <strong>Mobile Number :</strong> {selectedCustomer.mobileNumber|| "N/A"}
              </td>
              <td>
                <strong>Email ID :</strong> {selectedCustomer.email|| "N/A"}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Pin Code :</strong> {selectedCustomer.pincode|| "N/A"}
              </td>
              <td>
                <strong>Post Office :</strong> {selectedCustomer.postOffice|| "N/A"}
              </td>
              <td>
                <strong>Bank Account :</strong> {selectedCustomer.bankAccount|| "N/A"}
              </td>
              <td>
                <strong>IFSC :</strong> {selectedCustomer.bankIFSC|| "N/A"}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <strong>Bank Branch :</strong> {selectedCustomer.bankBranch|| "N/A"}
              </td>
              <td colSpan={2}>
                <strong>Bank Name :</strong> {selectedCustomer.bankName|| "N/A"}
              </td>
            </tr>
          </tbody>
        </table>

        <h3 className="CustomerCertificatessection-title">Address</h3>
        <table className="CustomerCertificatesinfo-table">
          <tbody>
            <tr>
              <td>
                <strong>Sub District :</strong> {selectedCustomer.subDistrict|| "N/A"}
              </td>
              <td>
                <strong>District :</strong> {selectedCustomer.district|| "N/A"}
              </td>
              <td>
                <strong>State :</strong> {selectedCustomer.state|| "N/A"}
              </td>
              <td>
                <strong>Country :</strong> {selectedCustomer.country|| "N/A"}
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                <strong>Current Address :</strong> {selectedCustomer.address|| "N/A"}
              </td>
              <td colSpan={2}>
                <strong>Parmanent Address :</strong> {selectedCustomer.address|| "N/A"}
              </td>
            </tr>
          </tbody>
        </table>

        <h3 className="CustomerCertificatessection-title">Other Details</h3>
        <table className="CustomerCertificatesinfo-table">
          <tbody>
            <tr>
              <td>
                <strong>Marital Status :</strong> {selectedCustomer.maritalStatus|| "N/A"}
              </td>
              <td>
                <strong>Date of Joining :</strong> {new Date(selectedCustomer.dateOfJoining).toLocaleDateString("en-GB")|| "N/A"}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="CustomerCertificatessign-section">
          <p>Signature of Applicant: __________________________</p>
          <p>Signature of Authorize: __________________________</p>
        </div>
      </div>
      {/* ✅ Print Button */}
      <div className="CustomerCertificates-print-btn-container">
        <button className="CustomerCertificatesprint-btn" onClick={generatePDF}>
          Download PDF
        </button>
      </div>
    </div>
  );
};

export default CustomerCertificates;
